import { useCallback, useEffect, useState } from 'react';
import { ToggleInput, IconLoader } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { setCardsEnabled } from '../../store/dictionaries/slice';
import {
  useLazyGetPSPDetailsQuery,
  useEditPSPDetailsMutation,
} from './store/services/details';
import { PSPDetailsKeys } from './types';

import cn from './styles.module.css';

const CardsSettings = () => {
  const {
    administrationDictionaries: { cardsEnabled },
    settings: {
      details: { pspDetails },
    },
  } = useAppSelector((state) => state);
  const [editError, setEditError] = useState('');

  const dispatch = useAppDispatch();

  const [getCardSettings, { isLoading }] = useLazyGetPSPDetailsQuery();
  const [edit, { isLoading: editIsLoading, isError }] =
    useEditPSPDetailsMutation();

  const onChangeCardsSettings = (checked: boolean) => {
    setEditError('');
    dispatch(setCardsEnabled(checked));

    edit({
      cardsEnabled: checked,
      key: PSPDetailsKeys.CARDS,
    });
  };

  const getCardSettingsAction = useCallback(async () => {
    const response = await getCardSettings();

    if (response && response.data) {
      const cardsSettings = response?.data?.data?.edges?.find(
        (item) => item?.node.key === PSPDetailsKeys.CARDS,
      );

      if (cardsSettings) {
        dispatch(setCardsEnabled(cardsSettings?.node?.data?.value as boolean));
      }
    }
  }, []);

  useEffect(() => {
    if (!pspDetails) {
      getCardSettingsAction();
    } else {
      const cardsSettings = pspDetails?.find(
        (item) => item?.key === PSPDetailsKeys.CARDS,
      );

      if (cardsSettings) {
        dispatch(setCardsEnabled(cardsSettings.data?.value as boolean));
      }
    }
  }, [pspDetails]);

  useEffect(() => {
    if (isError) {
      dispatch(setCardsEnabled(!cardsEnabled));
      setEditError('Something went wrong. Try again');
    }
  }, [isError]);

  useEffect(() => {
    let title = 'Settings: Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.cardsSettingsLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <>
        <ToggleInput
          name="cardsEnabled"
          checked={cardsEnabled}
          title="Availability of the card programme"
          onChange={(e) => onChangeCardsSettings(e.target.checked)}
          disabled={editIsLoading}
        />
        {editError && <div className={cn.cardsEditError}>{editError}</div>}
      </>
    );
  }

  return <div className={cn.cardsSettingsWrapper}>{content}</div>;
};

export default CardsSettings;
